/* eslint-disable jsx-a11y/label-has-associated-control */
import { Button, Input } from 'antd'
import { ArrowUpRight, Eye, EyeSlash } from 'phosphor-react'
import React, { useCallback, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
// import LoginFram from '../../../assets/images/loginFramNew1.png'
import { Container, Modal, Row, Spacer } from '@nextui-org/react'
import { toast } from 'react-hot-toast'
import HelmetComponent from '../../../Component/Helmet'
import forgotPasswordPicture from '../../../assets/images/forgotPassword.jpg'
import LoginFram from '../../../assets/images/framLogin2.png'
import j2bdLogo from '../../../assets/images/j2bd.svg'
import holloLogo from '../../../assets/images/loghollo.png'
import { setTalent } from '../../../redux/reducers/talentSlice'
import AuthTalent from '../../../services/AuthTalent'
import { errorsForm } from '../../../services/errorsForm'
import { app } from '../../../services/feathers'
import { checkFeatureFlag } from '../../../utils/featureFlag'
import * as S from './styles'

const Login = () => {
  const { t } = useTranslation(['login', 'common'], {
    useSuspense: false,
  })
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [resetPasswordError, setResetPasswordError] = useState('')

  useEffect(() => {
    if (AuthTalent.loggedIn()) {
      history.replace('/app')
    }
  }, [history])

  const login = async ({ email, password }) => {
    setLoading(true)
    try {
      const response = await AuthTalent.login(email, password)
      dispatch(setTalent(response.talent))
      history.push('/app/jobs')
    } catch (err) {
      errorsForm(err, t)
    } finally {
      setLoading(false)
    }
  }

  const goToLoginHR = () => {
    const currentUrl = window.location.href.split('/')[2]

    if (checkFeatureFlag) {
      window.location.href = 'https://job2bedone-partners.hollo.io/login'
    } else if (currentUrl.includes('localhost')) {
      window.location.href = 'http://localhost:3001/login'
    } else if (currentUrl.includes('staging')) {
      window.location.href = 'https://app-staging.hollo.io/login'
    } else {
      window.location.href = 'https://app.hollo.io/login'
    }
  }

  const handleResetPassword = useCallback(() => {
    if (email) {
      app
        .service('talent-send-reset-password')
        .create({
          email,
          domainJ2BD: checkFeatureFlag ? true : undefined,
        })
        .then(() => {
          toast.success(
            t(
              'login:askNewPassword.toast.success',
              'Un mail vous a été envoyé pour réinitialiser votre mot de passe',
            ),
          )
          setVisible(false)
        })
        .catch((err) => {
          if (err.message.includes('Email is invalid')) {
            setResetPasswordError('invalidEmail')
          }
        })
    }
  }, [email])

  const closeHandler = () => {
    setVisible(false)
  }

  const [passwordVisible, setPasswordVisible] = useState(false)

  const handleTogglePassword = () => {
    setPasswordVisible(!passwordVisible)
  }

  return (
    <S.Login>
      <HelmetComponent
        faviconUrl={checkFeatureFlag ? j2bdLogo : holloLogo}
        name={checkFeatureFlag ? 'J2BD Partners' : 'Hollo'}
      />
      <div
        className="left-img"
        style={{
          backgroundImage: `linear-gradient(0deg, rgba(13, 32, 95, 0.5), rgba(13, 32, 95, 0.5)), url(${LoginFram})`,
        }}
      >
        {/* <img src={LoginFram} alt="backgroundImage" /> */}
      </div>

      <div className="wrap">
        <div className="loginForm">
          <div className="title-row">
            <img
              src={checkFeatureFlag ? j2bdLogo : holloLogo}
              height={40}
              alt=""
              className="logo"
            />
            <h3 className="title">
              {checkFeatureFlag
                ? t('login:welcomJ2BD', 'Bienvenue sur J2BD Partners')
                : t('login:welcom', 'Bienvenue chez Hollo')}
            </h3>
          </div>

          <div className="switch-page">
            <Button className="active">
              {t('login:candidat', 'Candidat')}
            </Button>
            <Button onClick={goToLoginHR}>
              {t('login:recruiter', 'Recruteur')}
            </Button>
          </div>

          <form onSubmit={handleSubmit(login)} className="input-form">
            <div className="dual-input">
              <Controller
                name="email"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Input
                    autoFocus
                    {...field}
                    className="input-form-in"
                    placeholder={t('login:inputs.email.placeholder')}
                  />
                )}
              />
              {errors.email && (
                <span>{t('login:inputs.email.emptyError')}</span>
              )}
              <Controller
                name="password"
                id="password"
                control={control}
                rules={{ required: true }}
                key="password"
                render={({ field }) => (
                  <div style={{ position: 'relative' }}>
                    <Input
                      {...field}
                      type={passwordVisible ? 'text' : 'password'}
                      className="input-form-in"
                      placeholder={t('login:inputs.password.placeholder')}
                      style={{ marginRight: '10px' }}
                    />
                    <Button
                      className="password-visible"
                      onClick={handleTogglePassword}
                      ghost
                      type="link"
                    >
                      {passwordVisible ? (
                        <Eye size={20} color="#889096" weight="fill" />
                      ) : (
                        <EyeSlash size={20} color="#889096" weight="fill" />
                      )}
                    </Button>
                  </div>
                )}
              />

              {errors.password && (
                <span>{t('login:inputs.password.emptyError')}</span>
              )}
            </div>
            <span
              className="forgot-password"
              data-cy="forgot-password-link"
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'escape') {
                  setVisible(true)
                }
              }}
              onClick={() => setVisible(true)}
            >
              {t('login:forgotPasswordBtn', 'Mot de passe oublié ?')}
            </span>
            <Button
              className="submit-button"
              type="submit"
              htmlType="submit"
              loading={loading}
            >
              {t('login:submitBtn')}
              <ArrowUpRight size={20} color="#F6F8FE" weight="bold" />
            </Button>

            <Modal
              width={520}
              closeButton
              blur
              aria-labelledby="modal-title"
              open={visible}
              onClose={closeHandler}
            >
              <Modal.Header>
                <Container>
                  <Row justify="center">
                    <img
                      src={forgotPasswordPicture}
                      alt="forgot password"
                      style={{ width: '80%' }}
                    />
                  </Row>
                </Container>
              </Modal.Header>
              <Modal.Body>
                <p style={{ textAlign: 'left', fontSize: '15px' }}>
                  Veuillez saisir votre adresse mail pour recevoir un lien de
                  réinitialisation de votre mot de passe.
                </p>
                <Spacer y={0.1} />
                <Input
                  autoFocus
                  placeholder={t('login:inputs.email.placeholder')}
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value)
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleResetPassword()
                    }
                  }}
                />
                {resetPasswordError === 'invalidEmail' && (
                  <span style={{ color: 'red' }}>
                    {t('login:askNewPassword.toast.noUserError')}
                  </span>
                )}
                <Spacer y={0.3} />
                <Button
                  block
                  className="basic-btn"
                  type="submit"
                  htmlType="submit"
                  loading={loading}
                  onClick={handleResetPassword}
                  tabIndex="0"
                >
                  Réinitialiser le mot de passe
                </Button>
              </Modal.Body>
              <Modal.Footer>
                <Spacer y={1} />
              </Modal.Footer>
            </Modal>
          </form>
        </div>
      </div>
    </S.Login>
  )
}

// const WrappedLogin = () => (
//   <LayoutOnboardingPages type="login">
//     <Login />
//   </LayoutOnboardingPages>
// )

export default Login
